import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Overlay } from '@r1-frontend/ui-kit/atoms/overlay';
import { getSizes } from '@r1-frontend/ui-kit/molecules/Popup/helpers';
import { TSizesProps } from '@r1-frontend/ui-kit/molecules/Popup/helpers/getSizes';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

export type PopupBaseProps = TSizesProps & {
    /**
     * Отображение попапа
     */
    isOpen: boolean,

    /**
     * Коллбек, вызываемый при закрытии попапа
     */
    onClose: () => void,

    /**
     * Выключает возможность закрыть popup
     */
    isCloseDisabled?: boolean,


    className?: string,
    children?: ReactNode,

    /**
     * Коллбек, вызываемый при клике на попап
     */
    onClick?: () => void,
};

const PopupBase = styled(
    ({ children, onClick, ...props }: PopupBaseProps): JSX.Element => (
        <Overlay {...props}>
            <article onClick={onClick} role={'dialog'}>
                {children}
            </article>
        </Overlay>
    ),
)`
    ${({ theme, isOpen }: ThemedProperties<PopupBaseProps>) => css`
        display: flex;
        justify-content: center;
        align-items: center;

        article[role="dialog"] {
            @keyframes elevate {
                from {
                    transform: translateY(100%);
                    opacity: 0;
                }
            }

            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;

            ${getSizes()}
            
            margin: ${theme.indents.xxs}px;
            padding: ${theme.indents.m}px;
            gap: ${theme.indents.s}px;
            border-radius: ${theme.radii.pixel.xl}px;
            background-color: ${theme.colors.system.background};
            opacity: 1;
            transform: translateY(0);
            animation: elevate 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
            overflow: hidden;

            @media (min-width: ${theme.breakpoints.tablet}) {
                min-width: 300px;
                max-width: 600px;
                padding: ${theme.indents.l}px;
                gap: ${theme.indents.m}px;
            }

           ${!isOpen && `
                transform: translateY(100%);
                transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
            `}
        }
    `};
`;

PopupBase.displayName = 'PopupBase';

export { PopupBase };
